import {formatDate} from "utils/valueFormatter.function";
import type {PreApprovalDetailsProps} from "types/documentData";
import {DocumentDataField} from "./DocumentDataField.component";

/** Whether the payment was pre-approved and, when it was, by whom and when. */
export const PreApprovalDetails = ({paymentDetails, translate}: PreApprovalDetailsProps) => {
    const isPreApproved = !!paymentDetails?.date;
    const preApprovedBy = isPreApproved ? paymentDetails.preApprovedBy : null;

    return (
        <>
            <DocumentDataField id="paymentPreApproved"
                               label={translate("documentData.paymentPreApproved")}
                               value={translate("boolean." + isPreApproved)}/>
            {preApprovedBy &&
                <DocumentDataField id="preApprovedBy"
                                   label={translate("documentData.preApprovedBy")}
                                   value={`${preApprovedBy.firstName || ""} ${preApprovedBy.lastName || ""}`.trim()}/>}
            {isPreApproved &&
                <DocumentDataField id="preApprovedWhen"
                                   label={translate("documentData.preApprovedWhen")}
                                   value={formatDate(paymentDetails.date, null)}/>}
        </>
    );
};
